import Vue from 'vue'
import Vuex from 'vuex'
import users from './modules/users'
import festivals from './modules/festivals'
import themes from './modules/themes'
import events from './modules/events'
import categories from './modules/categories'
import categoryGroups from './modules/categoryGroups'
import taxonomyGroups from './modules/taxonomyGroups'
import types from './modules/types'
import organizations from './modules/organizations'
import contracts from './modules/contracts'
import locations from './modules/locations'
import prices from './modules/prices'
import resources from './modules/resources'
import pillars from './modules/pillars'
import { queueton } from './modules/queueton'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    users,
    festivals,
    themes,
    events,
    categories,
    types,
    organizations,
    contracts,
    locations,
    prices,
    resources,
    pillars,
    categoryGroups,
    taxonomyGroups,
    queueton
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
})
